import { mapMutations } from 'vuex';
import IconPlay from '@/components/icons/IconPlay.vue';
import { BLOG_VIDEOS_TYPE, getVideoConfig, VIDEO_TYPE } from '@/helpers';
import ImageCard from '@/components/@general/ImageCard/index.vue';

export default {
  name: 'VideoCard',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: BLOG_VIDEOS_TYPE.VIDEOS
    }
  },
  data() {
    return {
      videoType: VIDEO_TYPE.DEFAULT,
      videoPreview: null
    };
  },
  components: {
    ImageCard,
    IconPlay
  },
  computed: {},
  mounted() {
    let { type, preview } = getVideoConfig(this.data.video, this.data.image);
    this.videoType = type;
    this.videoPreview = preview;
  },
  methods: {
    ...mapMutations({
      modalOpen: 'app/MODAL_OPEN',
      modalSetData: 'app/MODAL_SET_DATA'
    }),
    onHandleVideoPlay() {
      this.modalSetData({ key: 'youtubeVideo', data: { link: this.data.video, type: this.videoType } });
      this.modalOpen('youtubeVideo');
    }
  }
};
